"use client";
import React from "react";
import DesktopHeader from "./desktop/DesktopHeader";
import MobileHeader from "./mobile/MobileHeader";

const Header = () => {
  return (
    <>
      <div className="hidden xl:block">
        <DesktopHeader />
      </div>
      <div className="xl:hidden">
        <MobileHeader />
      </div>

      <div className="h-1 bg-red-700 fixed top-0 left-0 z-50 w-0"></div>
    </>
  );
};

export default Header;
